// Logo and icon color switching - mobile only (overrides header settings)
(function() {
  // Only run on mobile
  if (window.innerWidth >= 750) return;
  
  const logoOriginal = document.querySelector('.header-logo__image-container--original');
  const logoInverse = document.querySelector('.header-logo__image-container--inverse');
  const header = document.querySelector('header-component');
  const drawer = document.querySelector('#Details-menu-drawer-container');
  
  if (!logoOriginal || !logoInverse || !header) return;
  
  // Filters for icon colors
  const lightGrayFilter = 'brightness(0) saturate(100%) invert(88%) sepia(4%) saturate(286%) hue-rotate(59deg) brightness(94%) contrast(86%)';
  const darkGrayFilter = 'brightness(0) saturate(100%) invert(21%) sepia(5%) saturate(659%) hue-rotate(353deg) brightness(95%) contrast(89%)';
  
  function isDrawerOpen() {
    return drawer && drawer.hasAttribute('open');
  }
  
  function updateLogo() {
    if (window.innerWidth >= 750) return;
    
    const sections = document.querySelectorAll('[data-logo-variant]');
    
    if (sections.length === 0) return;
    
    const headerBottom = header.getBoundingClientRect().bottom;
    let currentVariant = null;
    
    sections.forEach(function(section) {
      const rect = section.getBoundingClientRect();
      if (rect.top <= headerBottom && rect.bottom >= 0) {
        currentVariant = section.dataset.logoVariant;
      }
    });
    
    if (currentVariant === 'light') {
      // Force light logo
      header.style.setProperty('--header-logo-display', 'none');
      header.style.setProperty('--header-logo-inverse-display', 'block');
      logoOriginal.style.setProperty('display', 'none', 'important');
      logoInverse.style.setProperty('display', 'block', 'important');
      header.style.setProperty('--header-icon-filter', lightGrayFilter);
      
    } else if (currentVariant === 'dark') {
      // Force dark logo
      header.style.setProperty('--header-logo-display', 'block');
      header.style.setProperty('--header-logo-inverse-display', 'none');
      logoOriginal.style.setProperty('display', 'block', 'important');
      logoInverse.style.setProperty('display', 'none', 'important');
      header.style.setProperty('--header-icon-filter', darkGrayFilter);
    }
  }
  
  // Close drawer when anchor link is clicked
  // function closeDrawerOnAnchorClick() {
  //   const drawerLinks = document.querySelectorAll('.menu-drawer a[href^="#"]');
    
  //   drawerLinks.forEach(function(link) {
  //     link.addEventListener('click', function() {
  //       if (drawer && drawer.hasAttribute('open')) {
  //         drawer.removeAttribute('open');
  //       }
  //     });
  //   });
  // }
  
  // Listen for drawer toggle event
  if (drawer) {
    drawer.addEventListener('toggle', function() {
      updateLogo();
    });
  }
  
  // Also use MutationObserver as backup
  if (drawer) {
    const observer = new MutationObserver(function() {
      updateLogo();
    });
    
    observer.observe(drawer, { 
      attributes: true,
      attributeFilter: ['open', 'class']
    });
  }
  
  // Initialize
  updateLogo();
  // closeDrawerOnAnchorClick();
  
  // Run on scroll
  window.addEventListener('scroll', updateLogo);
})();